import { InboxDemoTheme } from '@inbox-demo-nx/theme';
import { DripsyProvider } from 'dripsy';
import { createContext, ReactNode, useContext } from 'react';

type ThemeContextValue = {
  isDarkTheme: boolean;
  theme: InboxDemoTheme;
};

const ThemeContext = createContext<ThemeContextValue>({} as any);

export const ThemeContextProvider = ({
  children,
  theme,
  isDarkTheme,
}: { children: ReactNode } & ThemeContextValue) => {
  return (
    <ThemeContext.Provider value={{ theme, isDarkTheme }}>
      <DripsyProvider theme={theme}>{children}</DripsyProvider>
    </ThemeContext.Provider>
  );
};

export const useIsDarkTheme = () => useContext(ThemeContext).isDarkTheme;
